import { combineReducers } from 'redux';
import { profiles, monitoring } from './profiles';
import { status } from './status';
import { user } from './user';
import { activeProfile } from './activeProfile';
import { dadata } from './daData';
import { edit } from './EditProfile/editProfile';
import { tariff } from './tariff';

const Authorization = combineReducers({
  status,
  profiles,
  monitoring,
  user,
  activeProfile,
  dadata,
  edit,
  tariff,
});
export { Authorization };
